export default "__VITE_ASSET__99644809__"